import {
    Box,
    Card,
    CardContent,
    Typography,
    Chip,
    Button,
    Divider,
    Switch,
    FormControlLabel,
    Alert,
} from "@mui/material";
import LockIcon from '@mui/icons-material/Lock';
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import StorageIcon from "@mui/icons-material/Storage";
import DeleteIcon from "@mui/icons-material/Delete";
import RefreshIcon from "@mui/icons-material/Refresh";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { formatBytes } from "./profilUtils";

function EinstellungenTab({
    swEnabled,
    swStatus,
    swInfo,
    notificationsEnabled,
    pushSubscribed,
    cacheSize,
    onSWToggle,
    onNotificationToggle,
    onPushToggle,
    onUpdateSW,
    onChangePasswordOpen,
    onDisableSW,
    onClearCache,
}) {
    const getStatusColor = () => {
        if (swStatus === 'registered') return '#34d399';
        if (swStatus === 'error') return '#f87171';
        return '#93c5fd';
    };

    const getStatusIcon = () => {
        if (swStatus === 'registered') return <CheckCircleIcon sx={{ color: '#34d399' }} />;
        if (swStatus === 'error') return <ErrorIcon sx={{ color: '#f87171' }} />;
        return null;
    };

    return (
        <Box>

            <Card sx={{ mb: 3, backgroundColor: '#1f2937', borderRadius: '16px', border: '1px solid rgba(239, 68, 68, 0.2)' }}>
                <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                    <Box display="flex" alignItems="center" gap={2} mb={2}>
                        <LockIcon sx={{ color: '#f87171', fontSize: 28 }} />
                        <Typography variant="h6" sx={{ color: '#e0f2fe', fontWeight: 600 }}>Passwort ändern</Typography>
                    </Box>
                    <Divider sx={{ mb: 2, borderColor: 'rgba(239, 68, 68, 0.2)' }} />
                    <Typography variant="body2" sx={{ color: '#93c5fd', mb: 2 }}>
                        Ändere dein Passwort, um dein Konto sicherer zu machen
                    </Typography>
                    <Button
                        variant="contained"
                        startIcon={<LockIcon />}
                        onClick={onChangePasswordOpen}
                        sx={{ background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', borderRadius: '16px', textTransform: 'none' }}
                    >
                        Passwort ändern
                    </Button>
                </CardContent>
            </Card>

            {/* Service Worker */}
            <Card sx={{ mb: 3, backgroundColor: '#1f2937', borderRadius: '16px', border: '1px solid rgba(59, 130, 246, 0.2)' }}>
                <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                    <Box display="flex" alignItems="center" gap={2} mb={2}>
                        <CloudDownloadIcon sx={{ color: '#3b82f6', fontSize: 28 }} />
                        <Typography variant="h6" sx={{ color: '#e0f2fe', fontWeight: 600 }}>Service Worker</Typography>
                    </Box>
                    <Divider sx={{ mb: 2, borderColor: 'rgba(59, 130, 246, 0.2)' }} />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Box>
                            <Typography variant="body2" sx={{ color: '#93c5fd', mb: 0.5 }}>Status</Typography>
                            <Box display="flex" alignItems="center" gap={1}>
                                {getStatusIcon()}
                                <Typography variant="body1" sx={{ color: getStatusColor() }}>
                                    {swStatus === 'registered' && 'Aktiv'}
                                    {swStatus === 'unregistered' && 'Inaktiv'}
                                    {swStatus === 'error' && 'Fehler'}
                                    {swStatus === 'unknown' && 'Wird geladen...'}
                                </Typography>
                            </Box>
                        </Box>
                        <FormControlLabel control={<Switch checked={swEnabled} onChange={onSWToggle} />} label="" />
                    </Box>
                    {swInfo && (
                        <Box sx={{ bgcolor: 'rgba(59, 130, 246, 0.1)', p: 1.5, borderRadius: '16px', mb: 2 }}>
                            <Typography variant="caption" sx={{ color: '#93c5fd' }}><strong>Scope:</strong> {swInfo.scope}</Typography>
                        </Box>
                    )}
                    <Box display="flex" gap={1} flexWrap="wrap">
                        {swEnabled && (
                            <>
                                <Button variant="outlined" size="small" startIcon={<RefreshIcon />} onClick={onUpdateSW} sx={{ color: '#3b82f6', borderColor: '#3b82f6', borderRadius: '16px' }}>Update prüfen</Button>
                                <Button variant="outlined" size="small" startIcon={<DeleteIcon />} onClick={onDisableSW} sx={{ color: '#f87171', borderColor: '#f87171', borderRadius: '16px' }}>Deaktivieren</Button>
                            </>
                        )}
                    </Box>
                </CardContent>
            </Card>


            {/* Benachrichtigungen */}
            <Card sx={{ mb: 3, backgroundColor: '#1f2937', borderRadius: '16px', border: '1px solid rgba(34, 197, 94, 0.2)' }}>
                <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                    <Box display="flex" alignItems="center" gap={2} mb={2}>
                        <NotificationsIcon sx={{ color: '#34d399', fontSize: 28 }} />
                        <Typography variant="h6" sx={{ color: '#e0f2fe', fontWeight: 600 }}>Benachrichtigungen</Typography>
                    </Box>
                    <Divider sx={{ mb: 2, borderColor: 'rgba(34, 197, 94, 0.2)' }} />

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Box>
                            <Typography variant="body2" sx={{ color: '#93c5fd', mb: 0.5 }}>Browser-Berechtigung</Typography>
                            <Typography variant="caption" sx={{ color: '#64748b' }}>Grundlegende Berechtigung für Benachrichtigungen</Typography>
                        </Box>
                        <FormControlLabel control={<Switch checked={notificationsEnabled} onChange={onNotificationToggle} />} label="" />
                    </Box>

                    <Divider sx={{ my: 2, borderColor: 'rgba(34, 197, 94, 0.1)' }} />

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Box sx={{ flex: 1 }}>
                            <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                                <Typography variant="body2" sx={{ color: '#93c5fd' }}>Push-Benachrichtigungen</Typography>
                                <Chip label={pushSubscribed ? 'Aktiv' : 'Inaktiv'} size="small" sx={{ bgcolor: pushSubscribed ? 'rgba(34, 197, 94, 0.2)' : 'rgba(100, 116, 139, 0.2)', color: pushSubscribed ? '#34d399' : '#64748b', height: '20px', fontSize: '0.7rem' }} />
                            </Box>
                            <Typography variant="caption" sx={{ color: '#64748b' }}>Erhalte Einladungen und wichtige Updates</Typography>
                        </Box>
                        <FormControlLabel control={<Switch checked={pushSubscribed} onChange={onPushToggle} disabled={!swEnabled} />} label="" />
                    </Box>

                    {!swEnabled && (
                        <Alert severity="warning" sx={{ mt: 2, bgcolor: 'rgba(251, 191, 36, 0.1)', color: '#fbbf24' }}>
                            Service Worker muss aktiviert sein für Push-Benachrichtigungen
                        </Alert>
                    )}

                    {swEnabled && pushSubscribed && (
                        <Box sx={{ bgcolor: 'rgba(34, 197, 94, 0.1)', p: 2, borderRadius: '16px', mt: 2 }}>
                            <Box display="flex" alignItems="center" gap={1} mb={1}>
                                <NotificationsActiveIcon sx={{ color: '#34d399', fontSize: 20 }} />
                                <Typography variant="body2" sx={{ color: '#34d399', fontWeight: 600 }}>Push-Benachrichtigungen sind aktiv</Typography>
                            </Box>
                            <Typography variant="caption" sx={{ color: '#64748b' }}>Du erhältst Benachrichtigungen über Gruppeneinladungen, Termine und wichtige Updates</Typography>
                        </Box>
                    )}
                </CardContent>
            </Card>

            {/* Speicher */}
            <Card sx={{ backgroundColor: '#1f2937', borderRadius: '16px', border: '1px solid rgba(168, 85, 247, 0.2)' }}>
                <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                    <Box display="flex" alignItems="center" gap={2} mb={2}>
                        <StorageIcon sx={{ color: '#a78bfa', fontSize: 28 }} />
                        <Typography variant="h6" sx={{ color: '#e0f2fe', fontWeight: 600 }}>Speicher</Typography>
                    </Box>
                    <Divider sx={{ mb: 2, borderColor: 'rgba(168, 85, 247, 0.2)' }} />
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" sx={{ color: '#93c5fd', mb: 1 }}>Belegter Speicher</Typography>
                        <Chip label={formatBytes(cacheSize)} sx={{ bgcolor: '#1e3a8a', color: '#e0f2fe' }} />
                    </Box>
                    <Button variant="outlined" size="small" startIcon={<DeleteIcon />} onClick={onClearCache} sx={{ color: '#f87171', borderColor: '#f87171', borderRadius: '16px' }}>
                        Cache leeren
                    </Button>
                </CardContent>
            </Card>
        </Box>
    );
}

export default EinstellungenTab;
